(function () {
	'use strict';

	angular.module('qbePortal').directive('qbModal',
		function () {
			return {
				templateUrl: '../ngviews/directives/qbModal.html',
				restrict: 'A',
				transclude: true,
				link: function (scope, element, attrs) {
					$('.js-modal-container').ddModals();

					//dd-5174-remove modal on save
					//scope.$root.$on('open-modal', openModal);
					//scope.$root.$on('close-modal', closeModal);

					function openModal(event, args) {
						setTimeout(function () {
							$.ddModals.open(args.modal);
						}, 1);
					}

					function closeModal(event, args) {
						$.ddModals.close(args.modal);
					}

				}
			};
		});

})();
